module.exports = __webpack_public_path__ + "img/person-9.843f855.webp";